"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.guestFactory = guestFactory;
exports.makeHotelProductFactory = makeHotelProductFactory;
var _constants = require("../constants");
var _constants2 = require("@tajawal/web-core-sdk-v2/lib/constants");
var _compact2 = _interopRequireDefault(require("lodash/compact"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _join2 = _interopRequireDefault(require("lodash/join"));
var _sumBy2 = _interopRequireDefault(require("lodash/sumBy"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _flatMap2 = _interopRequireDefault(require("lodash/flatMap"));
var _dateFns = require("date-fns");
var _hotelDetails = require("../utils/hotel-details.utils");
var _language = require("../utils/language.utils");
var _hotel = require("../utils/hotel.utils");
var EN = _constants2.LANGUAGE.EN;

/**
 * make hotel product factory
 * @param {boolean} isRtl English or Arabic
 * @param {string} language English or Arabic
 * @returns {Function} hotelProductFactory
 */
function makeHotelProductFactory() {
  var isRtl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EN;
  var dateFormat = 'DD MMM YYYY';
  var paramDateFormat = 'DD-MM-YYYY';

  /**
   * hotel product factory
   * @param {Object} data plain unformatted hotel product from cart's products
   * @param {Function} convertAndFormatPrice
   * @returns {Object} formatted hotel product
   */
  return function hotelProductFactory(data) {
    var convertAndFormatPrice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
      return x;
    };
    var rooms = (0, _get2["default"])(data, 'options.room', []).map(function (room) {
      return roomFactory(room, language);
    });
    var hasSimilarRooms = rooms.length > 1 && (0, _uniq2["default"])((0, _flatMap2["default"])(rooms, 'name')).length === 1;
    var checkInDate = (0, _dateFns.parse)((0, _get2["default"])(data, 'options.checkInDate'));
    var checkOutDate = (0, _dateFns.parse)((0, _get2["default"])(data, 'options.checkOutDate'));
    var stayCompleted = (0, _dateFns.isSameDay)(checkInDate) || (0, _dateFns.isAfter)(new Date(), checkInDate);
    var status = (0, _get2["default"])(data, 'status', null);
    var paymentStatus = (0, _get2["default"])(data, 'paymentStatus', null);
    var endUserStatus = (0, _hotel.getHotelOrderEndUserStatus)({
      stayCompleted: stayCompleted,
      paymentStatus: paymentStatus,
      bookingStatus: status
    });
    return {
      id: (0, _get2["default"])(data, 'options.atgHotelId'),
      tvId: (0, _get2["default"])(data, 'options.hotelId'),
      productId: (0, _get2["default"])(data, 'id'),
      name: (0, _language.translate2keysLabel)((0, _get2["default"])(data, 'options'), 'hotelName', language),
      address: (0, _language.translate2keysLabel)((0, _get2["default"])(data, 'options'), 'address', language),
      latitude: (0, _get2["default"])(data, "options.geoLocation.Latitude"),
      longitude: (0, _get2["default"])(data, "options.geoLocation.Longitude"),
      imageUrl: (0, _get2["default"])(data, 'defaultImage.url'),
      starRating: +(0, _get2["default"])(data, 'options.starRating', 0),
      city: (0, _language.translate2keysLabel)((0, _get2["default"])(data, 'options'), 'city', language),
      checkIn: (0, _dateFns.format)((0, _dateFns.parse)((0, _get2["default"])(data, 'options.checkInDate')), dateFormat),
      checkOut: (0, _dateFns.format)((0, _dateFns.parse)((0, _get2["default"])(data, 'options.checkOutDate')), dateFormat),
      checkInParam: (0, _dateFns.format)((0, _dateFns.parse)((0, _get2["default"])(data, 'options.checkInDate')), paramDateFormat),
      checkOutParam: (0, _dateFns.format)((0, _dateFns.parse)((0, _get2["default"])(data, 'options.checkOutDate')), paramDateFormat),
      checkInDate: checkInDate,
      checkOutDate: checkOutDate,
      stayCompleted: stayCompleted,
      numberOfNights: (0, _get2["default"])(data, 'options.numberOfNights', 0),
      countryCode: (0, _get2["default"])(data, 'options.countryCode', ''),
      chainCode: (0, _get2["default"])(data, 'options.chainCode'),
      expireAt: (0, _get2["default"])(data, 'additionalData.itemValidation.expiredAt'),
      status: status,
      paymentStatus: paymentStatus,
      endUserStatus: endUserStatus,
      rooms: rooms,
      hasSimilarRooms: hasSimilarRooms,
      totalAdultsCount: (0, _sumBy2["default"])(rooms, 'adultsCount'),
      totalKidsCount: (0, _sumBy2["default"])(rooms, 'kidsCount'),
      specialRequest: (0, _get2["default"])(data, 'additionalData.specialRequest'),
      totalGuestsCount: (0, _sumBy2["default"])(rooms, function (r) {
        return r.adultsCount + r.kidsCount;
      }),
      roomsQuery: (0, _hotelDetails.formatRoomsQueryNew)((0, _get2["default"])(data, 'additionalData.searchAttributes.room')).replace('rooms=', ''),
      hotelSearchRoomsQuery: (0, _hotelDetails.formatRoomsQueryNew)((0, _get2["default"])(data, 'additionalData.searchAttributes.room'), '/').replace('rooms=', ''),
      tourismFee: tourismFeeFactory((0, _get2["default"])(data, 'options.tourismFee', {})),
      cancellation: cancellationFactory((0, _get2["default"])(data, 'additionalData.cancellationPolicies', {}), convertAndFormatPrice),
      firstCancellationDate: (0, _get2["default"])(data, 'options.firstCancellationDate'),
      searchQuery: (0, _get2["default"])(data, 'additionalData.searchAttributes.query', ''),
      totalPrice: (0, _get2["default"])(data, 'price.total'),
      convertedTotalPrice: convertAndFormatPrice((0, _get2["default"])(data, 'price.total')),
      tax: (0, _get2["default"])(data, 'price.tax'),
      basePrice: (0, _get2["default"])(data, 'price.base'),
      netTotalPrice: (0, _get2["default"])(data, 'price.total') - (0, _get2["default"])(data, 'price.outputVatMeta')
    };
  };
}

/**
 * guestFactory
 * @param {Object} data
 */
function guestFactory(data) {
  var firstName = (0, _get2["default"])(data, 'firstName');
  var lastName = (0, _get2["default"])(data, 'lastName');
  return {
    id: (0, _get2["default"])(data, 'id'),
    title: (0, _get2["default"])(data, 'title'),
    firstName: firstName,
    lastName: lastName,
    fullName: (0, _join2["default"])((0, _compact2["default"])([firstName, lastName]), ' ')
  };
}

/**
 * room factory for hotel product rooms
 * @param {Object} data plain hotel room object
 * @param {string} language
 * @returns {Object} formatted room
 */
function roomFactory(data, language) {
  return {
    id: (0, _get2["default"])(data, 'id'),
    basis: (0, _get2["default"])(data, 'RoomBasis', (0, _get2["default"])(data, 'roomBasis')),
    bedding: (0, _language.translateObjectLabel)((0, _get2["default"])(data, 'roomBedding'), language),
    view: (0, _language.translateObjectLabel)((0, _get2["default"])(data, 'roomView'), language),
    name: (0, _language.translate2keysLabel)(data, 'roomName', language),
    adultsCount: (0, _get2["default"])(data, 'AdultsCount'),
    kidsCount: (0, _get2["default"])(data, 'kidsAges', []).length,
    kidsAges: (0, _get2["default"])(data, 'kidsAges', [])
  };
}

/**
 * tourism fee factory for hotel products
 * @param {Object} data plain tourism fee object
 * @returns {Object} formatted tourism fee
 */
function tourismFeeFactory(data) {
  return {
    fee: Number((0, _get2["default"])(data, 'tourismFee')),
    totalFee: Number((0, _get2["default"])(data, 'totalTourismFee')),
    taxPerType: (0, _get2["default"])(data, 'taxPerType'),
    currency: (0, _get2["default"])(data, 'feeCurrency')
  };
}

/**
 * cancellation factory for hotel products
 * @param {Object} data plain cancellation policies object
 * @param {Function} convertAndFormatPrice
 * @returns {Object} formatted cancellation policies
 */
function cancellationFactory(data) {
  var convertAndFormatPrice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };
  var hasFreeCancellation = (0, _get2["default"])(data, 'hasFreeCancellation');
  return {
    hasPayLater: ((0, _get2["default"])(data, 'bookingMethod', []) || []).map(function (m) {
      return m.name;
    }).some(function (m) {
      return m === _constants.BOOKING_METHODS.PAY_LATER;
    }),
    hasFreeCancellation: hasFreeCancellation,
    expireAt: (0, _get2["default"])(data, 'cancellationPolicy[0].expireAt'),
    isNonRefundable: !hasFreeCancellation,
    bookingRemarks: (0, _get2["default"])(data, 'bookingRemarks'),
    cancellationPolicies: ((0, _get2["default"])(data, 'cancellationPolicy') || []).map(function (policy) {
      return cancellationPoliciesFactory(policy, convertAndFormatPrice);
    })
  };
}

/**
 * cancellation policies factory for hotel products cancellation policies
 * @param {Object} data plain cancellation policy object
 * @param {Function} convertAndFormatPrice
 * @returns {Object} formatted cancellation policy
 */
function cancellationPoliciesFactory(data) {
  var convertAndFormatPrice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };
  return {
    description: (0, _get2["default"])(data, 'description', ''),
    finalRate: (0, _get2["default"])(data, 'rateInfo.finalRate', 0),
    convertedFinalRate: convertAndFormatPrice((0, _get2["default"])(data, 'rateInfo.finalRate', 0)),
    expireAt: (0, _get2["default"])(data, 'expireAt')
  };
}